/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data IDs used in the Events screen.
 * @export
 */
export const EVENTS_DATA_IDS = {
  createEvent: `Button: Create event`,
  deleteEventDialog: `Dialog: Delete event confirmation dialog`,
  deleteEventDialogButtonCancel: `Button: Cancel delete event`,
  deleteEventDialogButtonDelete: `Button: Delete event`,
  deleteEventDialogError: `Error message: Delete event error`,
  eventActionMenuButton: `Action menu: Event menu button`,
  eventActionMenuCreateDataIntegration: `Action menu item: Create data integration`,
  eventActionMenuCreateWebBehavior: `Action menu item: Create web behavior`,
  eventActionMenuItemDelete: `Action menu item: Delete event`,
  eventActionMenuItemViewDetails: `Action menu item: View event details`,
  eventItem: `Event list: Event item`,
  eventItemDescription: `Event item: Event description`,
  eventItemTitle: `Event item: Event title`,
  eventsListEmptyState: `Events list: No events`,
  toastSuccessDeleteEvent: `Toast: Event deleted`,
};
